
import { helpers, required, minValue, maxValue, requiredIf } from "@vuelidate/validators";
import { computed } from "vue";

import { CholesterolFormState } from "./CholesterolReadings.vue";
import { maxDecimalPrecisionValidator } from "@/utils/validators";

export default (state: CholesterolFormState) => computed(() => ({
    readingdate: {
        required: helpers.withMessage("The reading date field is required.",
            required),
    },
    cholesterolReadingsType: {
        required: helpers.withMessage("The cholesterol readings type field is required.",
            required),
    },
    LDL: {
        requiredIf: helpers.withMessage("The LDL field is required.",
            requiredIf(() => {
                return state.currentReading?.cholesterolReadingsType === "0";
            })),
        maxValue: helpers.withMessage("The LDL field must be 999.999 or less.",
            maxValue(999.999)),
        minValue: helpers.withMessage("The LDL field must be 0.001 or more.",
            minValue(0.001)),
        decimalPrecision: maxDecimalPrecisionValidator(6, "LDL"),
    },
    HDL: {
        requiredIf: helpers.withMessage("The HDL field is required.",
            requiredIf(() => state.currentReading?.cholesterolReadingsType === "0")),
        maxValue: helpers.withMessage("The HDL field must be 999.999 or less.",
            maxValue(999.999)),
        minValue: helpers.withMessage("The HDL field must be 0.001 or more.",
            minValue(0.001)),
        decimalPrecision: maxDecimalPrecisionValidator(6, "HDL"),
    },
    TOTAL: {
        requiredIf: helpers.withMessage("The total Cholesterol reading field is required.",
            requiredIf(() => state.currentReading?.cholesterolReadingsType === "1")),
        maxValue: helpers.withMessage("The total Cholesterol reading field must be 999.999 or less.",
            maxValue(999.999)),
        minValue: helpers.withMessage("The total Cholesterol reading field must be 0.001 or more.",
            minValue(0.001)),
        decimalPrecision: maxDecimalPrecisionValidator(6, "total Cholesterol reading"),
    },
}));
